import React, { Component } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Avatar, Button, CssBaseline, TextField, Grid, Typography, CircularProgress, Container, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { QueuePlayNext, DeleteForever } from '@mui/icons-material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import Api from '../../services/api';
import CustomizedSnackbars from '../../components/material-snackbars';
import HeaderMenu from '../../components/header-menu';
import { connect } from 'react-redux';
import { browserHistory } from '../../helpers/history';
import { FormattedMessage, injectIntl } from 'react-intl';
import SimpleAutoComplete from '../../components/auto-complete/autocomplete';
import SimpleCheckBox from '../../components/checkbox/check';
import FlightLand from '@mui/icons-material/FlightLand';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import * as Service from '../../services/organizationaccountemail.service';
import * as componentActions from '../../redux/actions/organizationaccountemails';
import { bindActionCreators } from 'redux';
import SimpleHelp from '../../components/help';
import { getAllByOrganizationIdSelectionModel as getAllAddressesByOrganizationIdSelecionModel } from '../../services/address.service'
import { getAllSelectionModelCanCreateCalledByOrganizationId as getAllOrganizationCategoryCanCreateCAlledByOrganizationId } from '../../services/organizationcategory.service'
import { getAllSelectionModel as getAllStatusSelectionModel } from '../../services/status.service'
import { getAllSelectionModel as getAllTypeSelectionModel } from '../../services/type.service'
import { PapiroConsole } from '../../utils/papiroConsole';
import MailSending from "src/components/mailsending";
import MailReceiving from "src/components/mailreceiving";
import { Tab as RTab, Tabs as RTabs, TabList as RTabList, TabPanel as RTabPanel } from 'react-tabs';

class OrganizationAccountEmailEdit extends Component {

  constructor(props) {
    super(props);
    PapiroConsole.log(this.props)
    PapiroConsole.log("this.props OrganizationAccountEmailEdit")
    const { userSession, organizationaccountemails } = this.props;

    this.fromProps = false
    if (this.props && this.props.location && this.props.location.state && this.props.location.state.from && this.props.location.state.from.length > 0)
      this.fromProps = true

    this.globalAdm = false;
    this.isClient = true;
    if (userSession.user.userrole == null) {
      Api.logoff();
    }

    if (!organizationaccountemails || (organizationaccountemails && !organizationaccountemails.organizationaccountemail)) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/calleds`
    }

    userSession.user.userrole.map((item, key) => {
      if (item.role.roletype != 3) {
        this.isClient = false;
      }
      if (item.role.roletype == 0) {
        this.globalAdm = true;
      }
    }
    );

    // console.log(organizationaccountemails);
    let item = organizationaccountemails.organizationaccountemail;
    this.initialState = {
      id: item.id,
      UpdatedUser: userSession.user.id,
      active: item.active,
      organizationid: item.organizationid,
      providertype: item.providertype,
      name: item.name,
      addressId: 0,
      organizationCategoryId: 0,
      statusId: 0,
      typeId: 0,
      addressemail: item.addressemail,
      idSend: 0,
      server: '',
      fromMail: '',
      port: '',
      cryptotype: '',
      passwordSend: '',
      user: '',
      authenticationrequired: false,
      authenticationmethodtypeId: '',
      cloudType: 0,
      authType: 0,
      clientId: "",
      clientSecret: "",
      redirectUris: "",
      tenantId: "",
      projectId: "",
      tokenUri: "",
      authUri: "",
      authProviderX509CertUrl: "",
      idReceived: 0,
      serverReceive: '',
      fromMailReceive: '',
      portReceive: '',
      cryptotypeReceive: '',
      passwordReceive: '',
      userReceive: '',
      authenticationrequiredReceive: false,
      authenticationmethodtypeIdReceive: '',
      cloudTypeReceive: 0,
      authTypeReceive: 0,
      clientIdReceive: "",
      clientSecretReceive: "",
      redirectUrisReceive: "",
      tenantIdReceive: "",
      projectIdReceive: "",
      tokenUriReceive: "",
      authUriReceive: "",
      authProviderX509CertUrlReceive: "",
      emailtest: '',
    };

    this.state = {
      item: this.initialState,
      files: [],
      loading: true,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      OrgList: [],
      ProviderList: [],
      CryptoList: [],
      AuthenticationList: [],
      addessesList: [],
      organizationCategoriesList: [],
      statusList: [],
      customProvider: 0,
      typesList: [],
      AuthTypeList: [],
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.changeValues = this.changeValues.bind(this);
    this.getAllAddressesByOrganizationIdSelecionModel = this.getAllAddressesByOrganizationIdSelecionModel.bind(this)
    this.getAllOrganizationCategoryCanCreateCAlledByOrganizationId = this.getAllOrganizationCategoryCanCreateCAlledByOrganizationId.bind(this)
    this.getAllStatusSelectionModel = this.getAllStatusSelectionModel.bind(this)
    this.getAllTypeSelectionModel = this.getAllTypeSelectionModel.bind(this)
    this.setCustomProvider = this.setCustomProvider.bind(this)
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await this.getOrg();
    await this.getAllAddressesByOrganizationIdSelecionModel()
    await this.getAllOrganizationCategoryCanCreateCAlledByOrganizationId()
    await this.getAllStatusSelectionModel()
    await this.getAllTypeSelectionModel()
    this.getProvider();
    this.getAuthentication();
    this.getCrypto();
    this.getCloudType()
    this.getAuthType()
    await this.getDados(1);
    await this.getDados(0);
    await this.setState({ loading: false });

    let search = this.props.location.search;

    let params = new URLSearchParams(search);
    let gmail_auth = params.get('gmail_auth');

    //alert(gmail_auth);

    if (gmail_auth + '' === 'true') {
      //alert('GMAIL OK');
      this.ReceivedMailOk();
    }
  };

  getAllAddressesByOrganizationIdSelecionModel = async _ => {
    const { organizationaccountemails } = this.props;

    let result = await getAllAddressesByOrganizationIdSelecionModel(this.state.item.organizationid)
    if (result && result.success) {
      if (organizationaccountemails != null && organizationaccountemails.organizationaccountemail != null && organizationaccountemails.organizationaccountemail.addressid != null && result.data != null) {
        var item = result.data.find(item => item.id == organizationaccountemails.organizationaccountemail.addressid)
        if (item != null)
          this.setState(prevState => ({
            item: {
              ...prevState.item,
              addressId: item
            }
          }));
      }
      this.setState({ addessesList: result.data });
    } else {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(result);
    }
  }

  getAllOrganizationCategoryCanCreateCAlledByOrganizationId = async _ => {
    const { organizationaccountemails } = this.props;

    let result = await getAllOrganizationCategoryCanCreateCAlledByOrganizationId(this.state.item.organizationid)
    if (result && result.success) {
      if (organizationaccountemails != null && organizationaccountemails.organizationaccountemail != null && organizationaccountemails.organizationaccountemail.organizationcategoryid != null && result.data != null) {
        var item = result.data.find(item => item.id == organizationaccountemails.organizationaccountemail.organizationcategoryid)
        if (item != null)
          this.setState(prevState => ({
            item: {
              ...prevState.item,
              organizationCategoryId: item
            }
          }));
      }
      this.setState({ organizationCategoriesList: result.data });
    } else {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(result);
    }
  }

  getAllStatusSelectionModel = async _ => {
    const { organizationaccountemails } = this.props;

    let result = await getAllStatusSelectionModel()
    if (result && result.success) {
      if (organizationaccountemails != null && organizationaccountemails.organizationaccountemail != null && organizationaccountemails.organizationaccountemail.statusid != null && result.data != null) {
        var item = result.data.find(item => item.id == organizationaccountemails.organizationaccountemail.statusid)
        if (item != null)
          this.setState(prevState => ({
            item: {
              ...prevState.item,
              statusId: item
            }
          }));
      }
      this.setState({ statusList: result.data });
    } else {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(result);
    }
  }

  getAllTypeSelectionModel = async _ => {
    const { organizationaccountemails } = this.props;

    let result = await getAllTypeSelectionModel()
    if (result && result.success) {
      if (organizationaccountemails != null && organizationaccountemails.organizationaccountemail != null && organizationaccountemails.organizationaccountemail.typeid != null && result.data != null) {
        var item = result.data.find(item => item.id == organizationaccountemails.organizationaccountemail.typeid)
        if (item != null)
          this.setState(prevState => ({
            item: {
              ...prevState.item,
              typeId: item
            }
          }));
      }
      this.setState({ typesList: result.data });
    } else {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(result);
    }
  }

  async getDados(type) {
    //Type = 0 Send
    this.setState({ loading: true });
    var result = await Service.getDados(this.state.item.id, type);

    // console.log(result);
    if (result.success) {
      if (type == 0) {
        this.setState(prevState => ({
          item: {
            ...prevState.item,
            idSend: result.data.id,
            server: result.data.server,
            fromMail: result.data.frommail,
            port: result.data.port,
            cryptotype: result.data.cryptotype,
            /*passwordSend: result.data.password,*/
            user: result.data.user,
            authenticationrequired: result.data.authenticationrequired,
            authenticationmethodtypeId: result.data.authenticationmethodtype,
            cloudType: result.data.cloudType,
            authType: result.data.authType,
            clientId: result.data.clientId,
            clientSecret: result.data.clientSecret,
            redirectUris: result.data.redirectUris,
            tenantId: result.data.tenantId,
            projectId: result.data.projectId,
            tokenUri: result.data.tokenUri,
            authUri: result.data.authUri,
            authProviderX509CertUrl: result.data.authProviderX509CertUrl,
          }
        }));
      } else {
        this.setState(prevState => ({
          item: {
            ...prevState.item,
            idReceive: result.data.id,
            serverReceive: result.data.server,
            fromMailReceive: result.data.frommail,
            portReceive: result.data.port,
            cryptotypeReceive: result.data.cryptotype,
            /*passwordReceive: result.data.password,*/
            userReceive: result.data.user,
            authenticationrequiredReceive: result.data.authenticationrequired,
            authenticationmethodtypeIdReceive: result.data.authenticationmethodtype,
            cloudTypeReceive: result.data.cloudType,
            authTypeReceive: result.data.authType,
            clientIdReceive: result.data.clientId,
            clientSecretReceive: result.data.clientSecret,
            redirectUrisReceive: result.data.redirectUris,
            tenantIdReceive: result.data.tenantId,
            projectIdReceive: result.data.projectId,
            tokenUriReceive: result.data.tokenUri,
            authUriReceive: result.data.authUri,
            authProviderX509CertUrlReceive: result.data.authProviderX509CertUrl,
          }
        }));
      }
    } else {
      this.setState({
        loading: false, openNotification: true, notificationVariant: 'error',
        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(result);
    }
  };
  async getOrg() {
    var result = await Service.getOrg();
    if (result.success) {
      this.setState({ OrgList: result.data });

    } else {
      this.setState({
        loading: false, openNotification: true, notificationVariant: 'error',
        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(result);
    }
  };
  getProvider() {
    var result = [];
    result.push({ id: '1', name: 'Google' });

    this.setState({ ProviderList: result });
  };
  getAuthentication() {
    var result = [];
    result.push({ id: '1', name: 'DKIM' });

    this.setState({ AuthenticationList: result });
  };
  getCrypto() {
    var result = [];
    result.push({ id: '1', name: 'SSL' });

    this.setState({ CryptoList: result });
  };

  getCloudType() {
    var result = []
    result.push({ id: '1', name: 'Custom' })
    result.push({ id: '2', name: 'GoogleMail' })
    result.push({ id: '3', name: 'MicrosoftOutlook' })
    result.push({ id: '4', name: 'MicrosoftHotmail' })
    result.push({ id: '5', name: 'Yahoo' })
    this.setState({ CloudTypeList: result })
  }

  getAuthType() {
    var result = []
    result.push({ id: '1', name: 'Default' })
    result.push({ id: '2', name: 'Oauth2' })
    this.setState({ AuthTypeList: result })
  }

  handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;

    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [name]: value
      }
    }));
  };

  setCustomProvider = async (value) => {
    const { intl } = this.props
    this.setState({ customProvider: value })

    let client_id = ''
    if (value == 1) {
      await Api.get('/token/oauth/gmail')
        .then(result => {
          if (result && result.data && result.data.success == true) {
            client_id = result.data.data
          } else {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: "error",
              notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
            })
          }
        })
        .catch(err => {
          console.log(err)
          console.log("err")
          const intl = this.props.intl
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(err)
        })
    } else if (value == 2) {
      await Api.get('/token/oauth/microsoft')
        .then(result => {
          if (result && result.data && result.data.success == true) {
            client_id = result.data.data
          } else {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: "error",
              notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
            })
          }
        })
        .catch(err => {
          console.log(err)
          console.log("err")
          const intl = this.props.intl
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(err)
        })
    } else if (value == 3) {
      this.setState((prevState) => ({
        ...prevState,
        item: {
          ...prevState.item,
          cloudType: 1,
          cloudTypeReceive: 1,
        }
      }))
    }
    if (client_id.length > 0) {
      if (value == 1) {
        //let client_id = "457475788861-49q3pp471r06rpv07i9liv73f4tgsnjr.apps.googleusercontent.com";
        let redirect_uri = `https%3A%2F%2F${document.location.host.replace(':', '%3A')}%2Fpt%2Fauthorize`;
        let scope = "https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fgmail.readonly https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fgmail.modify";
        //state = tela a ser redirecionada, id da org, tab da tela de edição da config
        let state = `config-edit ${this.state.item.configid} 1`;
        var url = `https://accounts.google.com/o/oauth2/auth?access_type=offline&client_id=${client_id}&prompt=select_account+consent&redirect_uri=${redirect_uri}&response_type=code&scope=${scope}&state=${state}`;
        PapiroConsole.log(redirect_uri)
        PapiroConsole.log("redirect_uri")
        document.location.href = url;
      } else if (value == 2) {
        let redirect_uri = `https%3A%2F%2F${document.location.host.replace(':', '%3A')}%2Fpt%2Fauthorize`;
        let scope = "openid offline_access https://graph.microsoft.com/Mail.Read https://graph.microsoft.com/Mail.Send https://graph.microsoft.com/User.Read";
        //state = tela a ser redirecionada, id da org, tab da tela de edição da config
        let state = `config-edit ${this.state.item.configid} 1`;
        var url = `https:///login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${client_id}&prompt=select_account+consent&redirect_uri=${redirect_uri}&response_type=code&scope=${scope}&state=${state}&response_mode=query`;
        PapiroConsole.log(redirect_uri)
        PapiroConsole.log("redirect_uri")
      }
    }
  }

  handleSubmit = async e => {
    const intl = this.props.intl;
    e.preventDefault();

    if (this.state.item.server == null || this.state.item.server.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.server.field" })
      });
      return false
    }
    if (this.state.item.fromMail == null || this.state.item.fromMail.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: `O campo 'E-mail' em 'Informações de Envio' é obrigatório`
      });
      return false
    }
    if (this.state.item.port == null || this.state.item.port.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.port.field" })
      });
      return false
    }
    if (this.state.item.cryptotype == null || this.state.item.cryptotype.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.crypto.field" })
      });
      return false
    }
    if (this.state.item.user == null || this.state.item.user.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.user.field" })
      });
      return false
    }
    if (this.state.item.passwordSend == null || this.state.item.passwordSend.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.password.field" })
      });
      return false
    }

    if (this.state.item.serverReceive == null || this.state.item.serverReceive.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.server.field.info" })
      });
      return false
    }
    if (this.state.item.fromMailReceive == null || this.state.item.fromMailReceive.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: `O campo 'E-mail' em 'Informações de Recebimento' é obrigatório`
      });
      return false
    }
    if (this.state.item.portReceive == null || this.state.item.portReceive.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.port.field.info" })
      });
      return false
    }
    if (this.state.item.cryptotypeReceive == null || this.state.item.cryptotypeReceive.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.crypto.field.info" })
      });
      return false
    }
    if (this.state.item.userReceive == null || this.state.item.userReceive.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.user.field.info" })
      });
      return false
    }
    if (this.state.item.passwordReceive == null || this.state.item.passwordReceive.length == 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.missing.password.field.info" })
      });
      return false
    }

    this.setState({ loading: true });

    if (this.state.item.responseemailisnewcalled === true && this.state.item.accompanimentcalledforresponseemail === true) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "organization.account.email.registration.email.answer.is.new.called" })

      });
    } else {
      let data = new FormData();

      for (let key in this.state.item) {
        if (key.toString().toLowerCase().indexOf('_date') > -1 || key.toString().toLowerCase().indexOf('date_') > -1) {
          data.append(key, moment(this.state.item[key]).format('YYYY/MM/DD HH:mm:ss'));
        } else if (key.toString().endsWith('Id')) {
          if (this.state.item[key] && this.state.item[key].id && this.state.item[key].id > 0)
            data.append(key, this.state.item[key].id)
          else if (this.state.item[key] && this.state.item[key] > 0)
            data.append(key, this.state.item[key])
        } else {
          data.append(key, this.state.item[key]);
        }
      }

      this.state.files.forEach(file => data.append('filesUpload', file));
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      Api.put('/organizationaccountemails', data, config)
        .then(result => {
          if (result.data.success) {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'success',
              notificationMessage: intl.formatMessage({ id: "edit.success" }),
            });


          }
          else {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: result.data && result.data.errors ? result.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })

            });
            Api.kickoff(result);
          }

        })
        .catch(err => {
          if (err.response && err.response.data && err.response.data.errors) {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
            });
          }
          else {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" }) + err.response.data
            });
          }
          Api.kickoff(err);
        });
    };
  }

  closeNotification() {
    this.setState({ openNotification: false });
  }

  async changeValues(stateName, value, text = '') {
    this.setState({ loading: true });
    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [stateName]: value
      }
    }));

    this.setState({ loading: false });

  };

  removeItem(file) {
    let array = [...this.state.files];
    let index = array.indexOf(file)
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ files: array });
    }
  }

  testSendMail = async () => {
    const intl = this.props.intl;
    this.setState({ loading: true });

    if (this.state.item.server != '' && this.state.item.port != '' && this.state.item.user != '' && this.state.item.emailtest != '' && this.state.item.fromMail != '') {
      var data = {
        idSend: this.state.item.idSend,
        server: this.state.item.server,
        fromMail: this.state.item.fromMail,
        port: this.state.item.port,
        passwordSend: this.state.item.passwordSend != null ? this.state.item.passwordSend : null,
        user: this.state.item.user,
        addressemail: this.state.item.emailtest,
      }

      await Api.post('/emails/testSend', data)
        .then(result => {
          if (result && result.data && result.data.success == true) {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: "success",
              notificationMessage: intl.formatMessage({ id: "email.sent" })
            });
          } else {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "error.verify.sending.info" })
            });
          }
        })
        .catch(err => {
          console.log(err)
          console.log("err")
          const intl = this.props.intl;
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: intl.formatMessage({ id: "error.verify.sending.info" })
          });
          Api.kickoff(err);
        });

    } else {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "insert.sending.info" }),
      })
    }
  }

  testReceivedMail = async () => {
    const intl = this.props.intl;
    this.setState({ loading: true });

    if (this.state.item.serverReceive != '' && this.state.item.portReceive != '' && this.state.item.userReceive != '' && this.state.item.fromMailReceive != '') {
      var data = {
        idReceived: this.state.item.idReceive,
        serverReceived: this.state.item.serverReceive,
        fromMailReceive: this.state.item.fromMailReceive,
        portReceived: this.state.item.portReceive,
        passwordReceived: this.state.item.passwordReceive != null ? this.state.item.passwordReceive : null,
        userReceived: this.state.item.userReceive,
      }

      await Api.post('/emails/testReceived', data)
        .then(result => {
          if (result && result.data && result.data.success == true) {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: "success",
              notificationMessage: intl.formatMessage({ id: "mailbox.read.success.first.half" }) + result.data.data + intl.formatMessage({ id: "mailbox.read.success.second.half" })
            })
          } else {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "error.verify.receiving.info" })
            })
          }
        })
        .catch(err => {
          console.log(err)
          console.log("err")
          const intl = this.props.intl
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: intl.formatMessage({ id: "error.verify.receiving.info" })
          })
          Api.kickoff(err)
        })
    } else {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "insert.receiving.info" }),
      })
    }
  }

  ReceivedMailOk = async () => {
    const intl = this.props.intl;
    this.setState({ loading: true });

    if (this.state.item.serverReceive != '' && this.state.item.portReceive != '' && this.state.item.userReceive != '' && this.state.item.fromMailReceive != '') {
      var data = {
        idReceived: this.state.item.idReceive,
        serverReceived: this.state.item.serverReceive,
        fromMailReceive: this.state.item.fromMailReceive,
        portReceived: this.state.item.portReceive,
        passwordReceived: this.state.item.passwordReceive != null ? this.state.item.passwordReceive : null,
        userReceived: this.state.item.userReceive,
      }
      await Api.post('/emails/testReceived', data)
        .then(result => {
          if (result && result.data && result.data.success == true) {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: "success",
              notificationMessage: intl.formatMessage({ id: "mailbox.read.success.first.half" }) + result.data.data + intl.formatMessage({ id: "mailbox.read.success.second.half" })
            });
          } else {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: "error",
              notificationMessage: intl.formatMessage({ id: "error.verify.receiving.info" })
            });
          }
        })
        .catch(err => {
          console.log(err)
          console.log("err")
          const intl = this.props.intl;
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: intl.formatMessage({ id: "error.verify.receiving.info" })
          });
          Api.kickoff(err);
        });

    } else {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: "insert.receiving.info" }),
      })
    }
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;
    const { item, AuthTypeList, CryptoList, CloudTypeList, OrgList } = this.state;
    const intl = this.props.intl;
    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`
    }

    return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
        >
          <div className={classes.drawerHeader} />

          <Container component='main' maxWidth='xl' style={{ paddingLeft: '10%', paddingRight: '10%', marginLeft: 0 }}>
            <CssBaseline />
            <div className={classes.paper} style={{ marginTop: 0 }}>
              <Grid container spacing={6}>
                <Grid item xs={12} sm={4}>
                  <Button variant='outlined' color='primary' onClick={() => {
                    this.fromProps ? this.props.history.push(`/${this.props.match.params.lang}/organization-edit`, { organizations: this.props.organizations, propTab: 14 }) : browserHistory.goBack()
                  }
                  }>{this.props.intl.formatMessage({ id: "back" })}</Button>
                </Grid>
                <Grid item xs={12} sm={8} />
              </Grid>
              <Avatar className={classes.avatar}>
                <QueuePlayNext />
              </Avatar>
              <Typography component='h1' variant='h5'>
                {intl.formatMessage({ id: "typography.add.item" })}
              </Typography>
              <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>

                <Grid container spacing={2}>
                  <Grid item xs={11} sm={11}>
                    <TextField fullWidth label={intl.formatMessage({ id: 'name' })} autoComplete='fname' variant='outlined' name='name' onChange={this.handleInputChange} value={item.name} required />
                  </Grid>
                  <Grid item xs={1} sm={1}>
                    <SimpleHelp message={intl.formatMessage({ id: "organization.account.email.registration.email.name" })} />
                  </Grid>
                  <Grid item xs={11} sm={11}>
                    <SimpleAutoComplete
                      label={intl.formatMessage({ id: "location" })}
                      options={this.state.addessesList}
                      stateName="addressId"
                      changeSelect={this.changeValues}
                      selected={item.addressId} />
                  </Grid>
                  <Grid item xs={1} sm={1}>
                    <SimpleHelp message="Endereço do chamado" />
                  </Grid>
                  <Grid item xs={11} sm={11}>
                    <SimpleAutoComplete
                      label={intl.formatMessage({ id: "category" })}
                      options={this.state.organizationCategoriesList}
                      stateName="organizationCategoryId"
                      changeSelect={this.changeValues}
                      selected={item.organizationCategoryId} />
                  </Grid>
                  <Grid item xs={1} sm={1}>
                    <SimpleHelp message="Categoria do chamado" />
                  </Grid>
                  <Grid item xs={11} sm={11}>
                    <SimpleAutoComplete
                      label={intl.formatMessage({ id: "menu.statuses" })}
                      options={this.state.statusList}
                      stateName="statusId"
                      changeSelect={this.changeValues}
                      selected={item.statusId} />
                  </Grid>
                  <Grid item xs={1} sm={1}>
                    <SimpleHelp message="Status do chamado" />
                  </Grid>
                  <Grid item xs={11} sm={11}>
                    <SimpleAutoComplete
                      label={intl.formatMessage({ id: "type" })}
                      options={this.state.typesList}
                      stateName="typeId"
                      changeSelect={this.changeValues}
                      selected={item.typeId} />
                  </Grid>
                  <Grid item xs={1} sm={1}>
                    <SimpleHelp message="Tipo do chamado" />
                  </Grid>
                  <Grid item xs={11} sm={11}>
                    <SimpleCheckBox label={intl.formatMessage({ id: 'active' })} name='active' stateName='active' changeSelect={this.changeValues} selected={item.active} />
                  </Grid>
                  <Grid item xs={1} sm={1}>
                    <SimpleHelp message={intl.formatMessage({ id: "organization.account.email.registration.email.active" })} />
                  </Grid>
                  <Grid item xs={11} sm={11}>
                    <SimpleCheckBox label={intl.formatMessage({ id: 'ResponseEmailIsNewCalled' })} name='responseemailisnewcalled' stateName='responseemailisnewcalled' changeSelect={this.changeValues} selected={item.responseemailisnewcalled} />
                  </Grid>
                  <Grid item xs={1} sm={1}>
                    <SimpleHelp message={intl.formatMessage({ id: "organization.account.email.registration.email.reply.new.called" })} />
                  </Grid>
                  <Grid item xs={11} sm={11}>
                    <SimpleCheckBox label={intl.formatMessage({ id: 'AccompanimentCalledForResponseEmail' })} name='accompanimentcalledforresponseemail' stateName='accompanimentcalledforresponseemail' changeSelect={this.changeValues} selected={item.accompanimentcalledforresponseemail} />
                  </Grid>
                  <Grid item xs={1} sm={1}>
                    <SimpleHelp message={intl.formatMessage({ id: "organization.account.email.registration.email.reply.new.accompaniment" })} />
                  </Grid>

                  <Grid item xs={11} sm={11} style={{ marginTop: '4px' }}>

                  </Grid>
                </Grid>

                <RTabs indicatorColor={""} >
                  <RTabList style={{ borderColor: '#BB8FCE' }}>
                    <RTab style={{ fontSize: "14px" }}><FlightTakeoffIcon /> {intl.formatMessage({ id: "sending.info" })} </RTab>
                    <RTab style={{ fontSize: "14px" }}><FlightLand /> {intl.formatMessage({ id: "receiving.info.imap" })}</RTab>
                  </RTabList>

                  <RTabPanel>
                    <MailSending
                      intl={intl}
                      item={item}
                      handleInputChange={this.handleInputChange}
                      changeValues={this.changeValues}
                      testSendMail={this.testSendMail}
                      AuthTypeList={AuthTypeList}
                      CryptoList={CryptoList}
                      CloudTypeList={CloudTypeList}
                    />
                  </RTabPanel>
                  <RTabPanel>
                    <MailReceiving
                      intl={intl}
                      item={item}
                      handleInputChange={this.handleInputChange}
                      changeValues={this.changeValues}
                      testReceivedMail={this.testReceivedMail}
                      AuthTypeList={AuthTypeList}
                      CryptoList={CryptoList}
                      CloudTypeList={CloudTypeList}
                      OrgsList={OrgList}
                      organizationaccountemail
                    />
                  </RTabPanel>

                </RTabs>

                <Grid container justify="flex-end" style={{ justifyContent: 'flex-end' }}>
                  <Grid item xs={12} sm={4} align-items-xs-center={'true'} justify-xs-flex-end={'true'}>
                    <Button
                      type='submit'
                      fullWidth
                      variant='contained'
                      color='primary'
                      className={classes.submit}
                    >
                      {this.props.intl.formatMessage({ id: "save" })}
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </div>

            {this.state.loading && (
              <Overlay>
                <CircularProgress color='secondary' />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />
          </Container>
        </main>
      </div>
    );
  }
}
OrganizationAccountEmailEdit.propTypes = {
  classes: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  organizationaccountemails: state.organizationaccountemails,
  organizations: state.organizations,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(OrganizationAccountEmailEdit)));

